import { BapGroup } from "./bap-group";
import { BapGroups } from "./bap-groups";
import { BapParam } from "./bap-param";
import { convertToOutputParamGroups, InputParamGroups } from "./bap-types";
import { BlockAnalyzed } from "./block-analyzed";

export class BlockAnalyzedParameters extends BlockAnalyzed {
    static override webComponentName: string = "block-analyzed-parameters";
    protected override _templateId: string = "block-analyzed-parameters";
    private btnReloadParams!: HTMLButtonElement;
    private btnApplyParams!: HTMLButtonElement;
    private modalInstance: bootstrap.Modal | null = null;
    private modalElement: HTMLElement | null = null;
    private componentId: string = "";
    constructor() {
        super();
        this.componentId = this.createRandomId();
        
    }
    protected get groups(): BapGroups | null {
        return this.querySelector('bap-groups');
    }
    protected collectActualValue(): any {
        let value = this.groups?.value || null;
        if(value) {
            return convertToOutputParamGroups(value);
        }
        return null;
    }
    
    protected isValidValue(value: any): boolean {
        return true; // non fa controlli sul valore
    }
    protected buildRenderingData(): Record<string, any> {
        const baseData = super.buildRenderingData();
        return {
            ...baseData,
            componentId: this.componentId,
        };
    }
    protected afterRender(): void {
        super.afterRender(); 
        this.querySelector('#testButton')?.
        addEventListener('click', (e:Event)=>{
            if(!this.targetElement) {
                console.warn(
                    `BlockAnalyzedParameters: 
                    targetElement ${this.target} not found`,
                this);
                return;
            }
        (this.targetElement as any)!.inputValue = 
        [
            [{"value": 70, "parameter_id": 1}, {"value": true, "parameter_id": 26}]
        ]
        })
        this.btnReloadParams = this.querySelector('button[data-reload-params]') as HTMLButtonElement;
        this.btnApplyParams = this.querySelector('button[data-apply-params]') as HTMLButtonElement;
        this.btnReloadParams?.addEventListener('click', (e: Event) => {
            e.preventDefault();
            e.stopPropagation();
            
            const bapGroups = this.querySelector('bap-groups') as BapGroups;
            // ricarica i parametri dallo stato iniziale
            if(bapGroups.initialValue) {
                bapGroups.value = bapGroups.initialValue;
            }
            setTimeout(() => {
                this.btnReloadParams.classList.add('d-none');
                // per evitare che onValueChange annulli il cambiamento
            }, 500);
        });
        this.btnApplyParams ?.addEventListener('click', (e: Event) => {
            e.preventDefault();
            e.stopPropagation();
            this.applyValueToTarget();
            this.closeModal();
        });
        this.modalElement = this.querySelector(`#paramsModal${this.componentId}`);
        this.modalInstance = window.bootstrap.Modal.getOrCreateInstance(this.modalElement as HTMLElement);
    }
    public openModal() {
        this.modalInstance?.show();
    }
    public closeModal() {
        this.modalInstance?.hide();
    }

    public onValueChange(value:InputParamGroups) {
        // chiamato da groups quando i parametri cambiano
        this.btnReloadParams.classList.remove('d-none');
    }
    public onValueComplete(value:InputParamGroups) {
        // chiamato da groups quando i parametri sono completi
        this.btnApplyParams.classList.remove('d-none');
        this.btnReloadParams.classList.add('d-none');
    }
    // questo applica tutti i valori all'input target  
    protected applyValueToTarget() {
        // i valori sono i parametri in formato JSON 
        const el = this.targetElement;
        const value = this.collectActualValue();
        if (!el) {
            console.warn(`BlockAnalyzedParameters: targetElement ${this.target} not found`, this);
            return;
        }
        if (!this.isValidValue(value)) {
            console.warn(`BlockAnalyzedParameters: value is not valid`, value, this);
            return;
        }
        (el as any)!.inputValue = value;
    }
    
    static registerElement(): void {
        super.registerElement();
        // registra i componenti figli
        BapGroups.registerElement();
        BapGroup.registerElement();
        BapParam.registerElement();
        
    }
}